module.exports = __webpack_public_path__ + "static/img/article_top_bt1.02d380e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/article_top_bt1.png
// module id = y5HV
// module chunks = 27